'use client'

import { cn } from '@/lib/utils'

interface CardWatermarkProps {
  className?: string
  /**
   * Opacity of the watermark (0-100)
   * @default 3
   */
  opacity?: number
  /**
   * Position of the watermark
   * @default 'bottom-right'
   */
  position?: 'bottom-right' | 'top-right' | 'center'
  /**
   * Size multiplier for the watermark
   * @default 1
   */
  scale?: number
}

const logoUrl = () =>
  `${process.env.NEXT_PUBLIC_BASE_PATH || ''}/brand/poonawalla-logo.png`

/**
 * Poonawalla logomark watermark for cards.
 */
export function CardWatermark({
  className,
  opacity = 3,
  position = 'bottom-right',
  scale = 1,
}: CardWatermarkProps) {
  const positionClasses = {
    'bottom-right': '-bottom-12 -right-12',
    'top-right': '-top-12 -right-12',
    center: 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
  }

  const size = 180 * scale

  return (
    <div
      className={cn(
        'pointer-events-none absolute z-0',
        positionClasses[position],
        className
      )}
      aria-hidden='true'
      style={{
        opacity: opacity / 100,
        width: size,
        height: size,
      }}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={logoUrl()}
        alt=''
        className='h-full w-full object-contain'
      />
    </div>
  )
}
